import { render, staticRenderFns } from "./HubungiKami.vue?vue&type=template&id=f3d79206&scoped=true"
import script from "./HubungiKami.vue?vue&type=script&setup=true&lang=js"
export * from "./HubungiKami.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d79206",
  null
  
)

export default component.exports